import { render, staticRenderFns } from "./addDict.vue?vue&type=template&id=41d3e7f4&"
import script from "./addDict.vue?vue&type=script&lang=js&"
export * from "./addDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports